const fullDateShortTimeFormatter = Intl.DateTimeFormat('fr-FR', {dateStyle: 'full', timeStyle: 'short'});
const fullDateOnlyFormatter = Intl.DateTimeFormat('fr-FR', {dateStyle: 'full'});

export const formatDate = (date:Date)=> fullDateOnlyFormatter.format(date)
export const formatDateTime = (date:Date)=> fullDateShortTimeFormatter.format(date)